import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'Douleutaras/redux/hooks';
import { usersSelector } from 'Douleutaras/redux/data/users/usersSlice';

const GENDER_MALE = 'male';
const GENDER_FEMALE = 'female';

// Returns seller's preposition and display name
export const useProGenderInfo = (sellerId: string) => {
  const { t } = useTranslation();

  const seller = useAppSelector(state => usersSelector.selectById(state, sellerId));

  const showCompanyName = seller?.attributes?.showCompanyName;
  const gender = seller?.attributes?.gender;

  let preposition: string = '';
  let prepositionAccusative: string = '';

  switch (true) {
    case showCompanyName:
      preposition = t('T.USER.PREPOSITION-COMPANY');
      prepositionAccusative = t('T.USER.PREPOSITION-ACCUSATIVE-COMPANY');
      break;
    case gender === GENDER_MALE:
      preposition = t('T.USER.PREPOSITION-MALE');
      prepositionAccusative = t('T.USER.PREPOSITION-ACCUSATIVE-MALE');
      break;
    case gender === GENDER_FEMALE:
      preposition = t('T.USER.PREPOSITION-FEMALE');
      prepositionAccusative = t('T.USER.PREPOSITION-ACCUSATIVE-FEMALE');
      break;
    default:
      preposition = t('T.USER.PREPOSITION-GENDER-UNKNOWN');
      prepositionAccusative = t('T.USER.PREPOSITION-ACCUSATIVE-GENDER-UNKNOWN');
  }

  const displayName = showCompanyName ? seller?.attributes?.sellerDisplayName : seller?.attributes?.firstNameVocative;
  const displayNameAccusative = showCompanyName ? seller?.attributes?.sellerDisplayName : seller?.attributes?.firstNameAccusative;

  return {
    displayName,
    preposition,
    displayNameAccusative,
    prepositionAccusative
  };
};
